import { useQuery } from "../../../hooks/use-query";
import { PlpSitemap, PlpSitemapLinker } from "./plp-sitemap";
import { useLocation } from "react-router";
import { useSitemapLinker } from "./use-sitemap-linker";

export type PlpRootSubpage = {
  tag: "root";
  openedFilterTabByFilterKey: string | undefined;
};

export type PlpFacetedSearchSubPage = Omit<PlpRootSubpage, "tag"> & {
  tag: "faceted-search";
  activatedFacets: { [facetKey: string]: Array<string> };
};

export type PlpSubpage =
  | PlpRootSubpage
  | PlpFacetedSearchSubPage
  | {
      tag: "category";
      categoryKey: string;
      subfamilyKey?: never;
      productKey?: never;
    }
  | {
      tag: "subfamily";
      categoryKey: string;
      subfamilyKey: string;
      productKey?: never;
    }
  | {
      tag: "product";
      categoryKey: string;
      subfamilyKey: string;
      productKey: string;
    }
  | {
      tag: "product-spare-parts";
      categoryKey: string;
      subfamilyKey: string;
      productKey: string;
    };

export function useSparePartsSubpage(): {
  pathname: string;
  subpage: PlpSubpage;
  sitemapLinker: PlpSitemapLinker;
} {
  const query = useQuery();
  const location = useLocation();
  const pathname = location.pathname;

  const sitemapLinker = useSitemapLinker(pathname);

  return { pathname: pathname, subpage: PlpSitemap.decode(query), sitemapLinker };
}
